module.exports = __webpack_public_path__ + "img/default.17d65944.jpg";